(function() {
    'use strict';

    angular
        .module('consinfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('video-informativo', {
            parent: 'entity',
            url: '/video-informativo',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'consinfApp.videoInformativo.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/video-informativo/video-informativos.html',
                    controller: 'VideoInformativoController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('videoInformativo');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('video-informativo-detail', {
            parent: 'video-informativo',
            url: '/video-informativo/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'consinfApp.videoInformativo.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/video-informativo/video-informativo-detail.html',
                    controller: 'VideoInformativoDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('videoInformativo');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'VideoInformativo', function($stateParams, VideoInformativo) {
                    return VideoInformativo.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'video-informativo',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('video-informativo-detail.edit', {
            parent: 'video-informativo-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/video-informativo/video-informativo-dialog.html',
                    controller: 'VideoInformativoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['VideoInformativo', function(VideoInformativo) {
                            return VideoInformativo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('video-informativo.new', {
            parent: 'video-informativo',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/video-informativo/video-informativo-dialog.html',
                    controller: 'VideoInformativoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                nomeProcedura: null,
                                versione: null,
                                nomeFile: null,
                                validoDa: null,
                                mimeType: null,
                                info: null,
                                note: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('video-informativo', null, { reload: 'video-informativo' });
                }, function() {
                    $state.go('video-informativo');
                });
            }]
        })
        .state('video-informativo.edit', {
            parent: 'video-informativo',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/video-informativo/video-informativo-dialog.html',
                    controller: 'VideoInformativoDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['VideoInformativo', function(VideoInformativo) {
                            return VideoInformativo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('video-informativo', null, { reload: 'video-informativo' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('video-informativo.delete', {
            parent: 'video-informativo',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/video-informativo/video-informativo-delete-dialog.html',
                    controller: 'VideoInformativoDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['VideoInformativo', function(VideoInformativo) {
                            return VideoInformativo.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('video-informativo', null, { reload: 'video-informativo' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
